<template>
	<div id="ticket-messages">
		<!-- модальное окно для корректировки текста сообщения -->
		<ticket-message-action :is-visible="showTicketMessageAction"
							   v-on:hide-ticket-message-action="showTicketMessageAction = false"
							   v-on:closed-ticket-open="updateMessages"
							   v-on:ticket-rated="updateMessages"
							   :ticket="{
				ticketId: ticketId,
				ticketNumber: ticketNumber,
				ticketTitle: ticketTitle,
				ticketTitleId: ticketTitleId
				}" />
		<md-dialog :md-active.sync="showChatMessagesWindowDialog" :md-click-outside-to-close="false">
			<chatMessagesWindow :dataObj="{newMessage}"
								@closeChatMessagesWindow="closeChatMessagesWindow()"
								@updateNewMessage="updateNewMessage($event)"
								:initialMessage="messages.length == 0 ? null : {
					number: messages[0].ticketNumber,
					title: this.messages[0].ticketTitle,
					date: messages[0].createTime.substring(0, 10),
					text: messages[0].text
				}"></chatMessagesWindow>
		</md-dialog>

		<close-ticket v-bind:is-visible="showCloseTicketDialog"
					  v-on:hide-close-dialog="showCloseTicketDialog = false;"
					  v-on:ticket-closed="updateMessages"
					  :ticket="{
				ticketId: ticketId,
				ticketNumber: ticketNumber,
				titleName: ticketTitle
				}"
					  :allowEmpty="true" />

		<!-- модальное окно для корректировки текста сообщения -->
		<md-dialog :md-active.sync="showEditMessageWindow" :md-click-outside-to-close="false">
			<editMessageWindow :dataObj="{editableMessage, userId}"
							   @closeEditMessageWindow="showEditMessageWindow = false"
							   @updateMessages="clickUpdate()"></editMessageWindow>
		</md-dialog>

		<md-toolbar id="messages-toolbar"
					class="md-dense md-transparent"
					md-elevation="2"
					style="padding: 0 10px;margin-bottom: 10px">
			<div class="md-toolbar-section-start">
				<md-dialog :md-active.sync="showDialogForNewMessage">
					<p class="dialog">
						Сообщение не отправлено.
						<br>Отправить?
					</p>
					<md-dialog-actions>
						<md-button class="md-primary" @click="sendMessage(newMessage)">Да</md-button>
						<md-button class="md-primary" @click="toggleShowTextarea()">Нет</md-button>
						<md-button class="md-primary" @click="showDialogForNewMessage = false">Отмена</md-button>
					</md-dialog-actions>
				</md-dialog>

				
				<div style="font-size:1rem">
					<b>Тема:</b>
					<span style="margin-left: 5px;">{{ticketTitle}}</span>
					<span>
						<b style="margin-left: 10px">Статус:</b>
						<span style="margin-left: 5px;">{{tn != 0 ? ticketState : 'Новая'}}</span>
					</span>
				</div>
			</div>
			
			<div class="md-toolbar-section-end">
				<md-button class="md-raised md-primary"
						md-theme="green"
						@click="showCloseTicketDialog = true"
						v-if="ticketState !== 'Закрыта' && tn != 0 && !loading">Закрыть заявку (вопрос решён)</md-button>
				<md-button class="md-primary md-raised" @click="closeWindow">Закрыть окно</md-button>
			</div>
		</md-toolbar>
	
		<ul v-if="messagesWithNew.length > 0" id="mlist" class="md-content md-scrollbar md-theme-default" :style="{height: tableHeight + 'px'}" @mousemove="move">
			<li v-for="message of messagesWithNew"
				:key="message.messageNpp"
				class="message-container">
				<span>
					<div class="rating-container" v-if="message.rating">
						<div class="rating-text">
							Оценка:
							<div class="stars-container">
								<span>
									<md-icon v-for="item in message.rating" :key="item" class="stars-icon">star</md-icon>
								</span>
								<span v-if="message.rating < 5">
									<md-icon v-for="item in 5 - message.rating" :key="item" class="stars-icon">star_border</md-icon>
								</span>
							</div>
						</div>
					</div>
					<div class="mes"
						:class="calcTypeOfMessage(message)"
						:style="calcNewMessage(message.messageNpp)">
						<div v-if="!message.isNew">
							<span v-if="message.messageAgent !== ''" class="message-title">
								{{ message.createTime }} {{message.messageAgent}}
							</span>
							<span v-if="message.messageClient !== ''" class="message-title">
								{{ message.createTime }}
								<span>{{calcMessageTitle(message)}}</span>
								<span class="done"><md-icon :style="`color:${calcSeenedByAgentsMessage(message.messageNpp, message.messageClient)};`">done</md-icon></span>
							</span>
							<span class="is-closing" v-if="message.closedByUser"><small>заявка закрыта аптекой</small></span>
							<span class="is-closing-spec" v-if="!message.closedByUser && message.messageNpp === lastMessage.messageNpp && ticketState === 'Закрыта'"><small>заявка закрыта специалистом</small></span>
						</div>
						<span v-else>
							<span class="message-title">Новое сообщение</span>
							<span class="attach-header" style="">
								<md-icon style="color: #000;">attach_file</md-icon>
								<span>Прикрепить файл:</span>
								<span id="attachments-link">
									<span @click="ticketState === 'Закрыта' ? correctChatMessages() : clickFileInput()" class="attach-label" >с компьютера</span>
									<md-tooltip md-delay="500">Прикрепить файлы с компьютера</md-tooltip>
								</span>
							</span>
						</span>
						<div class="emails" v-if="message.emails">
							<ul>
								<li :key="item.key" v-for="item of parseEmails(message.emails, message.messageClient, clientEmail)" v-if="item.value">
									<b>{{item.key}}</b>{{item.value}}
								</li>
							</ul>
						</div>
						<pre v-if="!message.isNew">{{calcClientMessage(message)}}</pre>
						<div class="new-message-block" @drop.prevent="onDrop" v-else>
							<textarea id="message" class="md-field" placeholder="Текст сообщения (прикрепите файл с помощью перетаскивания или вставьте снимок экрана)" v-model.trim="newMessage" @change="toggleChanges()" @click="correctChatMessages" @paste="onPaste"></textarea>
							<div class="attach-controls" v-if="message.isNew">
								<span class="attach-label">с телефона (QR)</span>
								<div class="qr-block" style="position: relative;">
									<img :src="qrData" class="qr-img" @click="qrClicked" :style="`${ticketState === 'Закрыта' ? 'opacity: 0;' : ''}`"/>
									<md-tooltip md-delay="500">Прикрепить фото или файлы с телефона</md-tooltip>
								</div>
								<md-button class="md-button md-dense md-raised md-primary md-theme-default"
										@click="sendMessage(newMessage)"
										:disabled="(files.length == 0 && !newMessage) || loading">
									Отправить
								</md-button>
							</div>
						</div>
						
						<div class="attachments" v-if="message.attachmentsData !== '' || message.isNew && files.length > 0">
							<md-icon style="color: #000;margin: 0">attach_file</md-icon>
							<span>Прикрепленные файлы:</span>
							<span style="display: flex; overflow-x: auto; white-space: nowrap;">
								<div class="img-container"
									 v-for="attachment of calcMessageAttachments(message.attachmentsData, message.isNew)"
									 :key="attachment.name">
									<div @click="messageAttachmentClicked(message, attachment)">
										<img
											v-if="attachment.file_data"
											:src="`data:image/jpeg;base64,${attachment.file_data}`"
											class="fit-image"
											v-bind:style="{transform: `rotate(${attachDeg(attachment, message.isNew)}deg)`}"
											/>
										<md-icon v-else :md-src="`${calcTypeOfAttachment(attachment)}`" class="fit-image" />
									</div>
									<span class="remove-attachment" v-if="attachment.file" @click="removeAttachment(attachment.file)">&times;</span>
									<md-tooltip md-direction="bottom">{{attachment.file_name}} &#8195; {{bytesToSize(attachment.file_size)}}</md-tooltip>
								</div>
							</span>
						</div>
					</div>
				</span>
			</li>
		</ul>
		<ul v-else id="mlist" class="md-content md-scrollbar md-theme-default" :style="{height: tableHeight + 'px'}">
			<li v-if="!loading && tn != 0" style="list-style: none;text-align: center;font-size: 1.2rem;font-weight: bold;margin-top: 1rem;">Сообщений не найдено</li>
		</ul>

		<!--прикрепление файлов-->
		<md-field style="display: none">
			<label>Прикрепить файлы</label>
			<md-file id="file-input" @md-change="onFileUpload($event)" multiple />
		</md-field>

		<md-dialog class="image-viewer-dialog" :md-active.sync="showImage" v-model="messageToImageShow">
			<md-dialog-content>
				<img :src="`${messageToImageShow ? messageToImageShow.file : ''}`" style="object-fit: contain; margin-left:auto; margin-right: auto;" id="gallery_image"
				v-bind:style="{transform: `rotate(${imageDeg}deg)`}">
			</md-dialog-content>
			<md-dialog-actions style="padding: 0px 8px 0px 8px">
				<md-button @click="messageToImageShow.download()">
					<md-icon>file_download</md-icon>
					<md-tooltip md-delay="500">Скачать</md-tooltip>
				</md-button>
				<md-button @click="rotateImage(-1)">
					<md-icon>rotate_left</md-icon>
					<md-tooltip>
						Повернуть против часовой стрелки
					</md-tooltip>
				</md-button>
				<md-button @click="rotateImage(1)">
					<md-icon>rotate_right</md-icon>
					<md-tooltip>
						Повернуть по часовой стрелке
					</md-tooltip>
				</md-button>
				<md-button @click="messageToImageShow.saveDeg(imageDeg)" :disabled="!canSaveDeg">
					<md-icon>save</md-icon>
					<md-tooltip>
						Сохранить поворот
					</md-tooltip>
				</md-button>
				<span style="margin-left: auto; margin-right: auto;">
					<md-button class="md-primary" @click="messageToImageShow.prev(messageToImageShow)" :disabled="messageToImageShow ? !messageToImageShow.allowPrev(messageToImageShow.att) : true">Назад</md-button>
					<md-button class="md-primary" @click="messageToImageShow.next(messageToImageShow)" :disabled="messageToImageShow ? !messageToImageShow.allowNext(messageToImageShow.att) : true">Вперёд</md-button>
				</span>
				<md-button class="md-secondary" @click="showImage = false">
					<md-icon>close</md-icon>
				</md-button>
			</md-dialog-actions>
		</md-dialog>

		<md-dialog :md-active.sync="showEmailDialog" class="email-dialog" @submit.prevent="sendUrlEmail">
			<form>
				<md-card>
					<md-card-header>
						<h3>Укажите e-mail и на него придет ссылка для загрузки файлов</h3>
					</md-card-header>
					<md-card-content>
						<md-field>
							<label for="email">e-mail</label>
							<md-input name="e-mail" id="e-mail" type="email" v-model="urlEmail" :disabled="urlEmailSending" />
						</md-field>
					</md-card-content>
					<md-card-actions>
						<md-button type="submit" class="md-primary" :disabled="urlEmailSending">Отправить</md-button>
					</md-card-actions>
				</md-card>
			</form>
		</md-dialog>
	</div>
</template>

<script>
	import axios from "axios";
	import {mapGetters} from "vuex";
	import chatMessagesWindow from "./chatMessagesWindow";
	import editMessageWindow from "./editMessageWindow";
	import {isEmpty} from '../utilities/utilities.js';
	import TicketMessageAction from './ticketMessageAction.vue';
	import CloseTicket from './closeTicket.vue';
	import Dnd from '../phone/dnd.vue';
	import QbIdb from '../idb/idb.js';

    const events = ['dragenter', 'dragover', 'dragleave', 'drop'];

	export default {
		components: {chatMessagesWindow, editMessageWindow, TicketMessageAction, CloseTicket, Dnd},
		name: "Messages",
		props: [],
		inject: ["getRowsPerPage", "getCurrentPage", "getLoading", "setLoading"],
		data: () => ({
			messages: [],
			newMessages: [],
			seenedByAgentsMessages: [],
			tableHeight: 700,
			newMessage: "",
			tn: 0,
			isChangeTicketTitle: false,
			newTicketTitle: "",
			showTextarea: true,
			changes: [],
			showDialogForNewMessage: false,
			timerId: 0,
			mouseMoveCounter: 0,
			firstLoad: true,
			files: [], //прикрепленные файлы
			showChatMessagesWindowDialog: false,
			showEditMessageWindow: false,
			editableMessage: Object.create(null),

			showTicketMessageAction: false,
			showCloseTicketDialog: false,

			showImage: false,
			messageToImageShow: null,
			qrData: null,
			qrUrl: null,
			uploadKey: "",
			showEmailDialog: false,
			urlEmail: null,
			urlEmailSending: false,
			db: null,
			imageDeg: 0,
            canSaveDeg: false
		}),

		computed: {
			...
				mapGetters([
					"CURRENTTABID",
					"OPENEDTICKETSTABS",
					"PRIORITIES",
					"CURRENTAPTEKA",
					'TICKETSWITHCHANGES',
					'CURRENTUSER',
					'USERID',
					'KNOWNFILETYPES',
					'COMPANYS',
					'LOGINUSERS',
                    'NEWTABTICKETTITLE'
				]),
			npp() {
				if (this.messages.length == 0) return "";
				return this.messages[0].ticketNpp;
			},
			ticketRealId() {
				let ticketId = this.ticketNumber;
				return ticketId == "" ? 0 : ticketId;
			},
			ticketNumber() {
				if (this.messages.length == 0) return "";
				return this.messages[0].ticketNumber;
			},
			ticketId() {
				return this.npp;
			},
			ticketStateRaw() {
				return this.messages.length > 0 ? this.messages[0].state : '';
			},
			ticketState() {
				const state = this.messages.length > 0 ? this.messages[0].state : '';
				switch (state) {
					case "open":
						return "В работе";
					case "close":
						return "Закрыта";
					case "new":
						return "Новая";
					default:
						return "";
				}
			},
			isChanged() {
				if (this.changes.length == 0) return false;
				return true;
			},
			loading: {
				get() {
					return this.getLoading();
				}
				,
				set(value) {
					this.setLoading(value);
				}
			},
			newTicketTitleFunc() {
				try {
					return JSON.parse(localStorage.newTabTicketTitle)
				} catch (error) {
					return {titleName: '', titleNpp: 0};
				}
			},
			ticketTitle: {
				get() {
					return this.messages.length === 0 ? this.newTicketTitleFunc.titleName : this.messages[0].ticketTitle;
				}
			},
			ticketTitleId: {
				get() {
					return this.messages.length === 0 ? this.newTicketTitleFunc.titleNpp : this.messages[0].ticketTitleId;
				}
			},
			// hasNewMessages() {
			// 	return this.messages.some(message => message.isSeen === false && message.messageAgent !== '')
			// },
			hasNewMessages() {
				return this.newMessages.length > 0;
			},
			attachmentsData() {
				let data = [];
				this.files.forEach(file => {
						let {name: file_name, size: file_size, type: file_type} = file;
						data.push({file_name, file_size, file_type});
					});
				return data;
			},
			clientEmail() {
				return this.CURRENTUSER.email || '';
			},
			clientEmailNew() {
                const a = this.CURRENTAPTEKA
                return (a && a.email ? 'fz:' + a.email : null) || this.CURRENTUSER.email || '';
            },
			lastMessage() {
				return this.messages.length ? this.messages[this.messages.length - 1] : Object.create(null);
			},
			userId() {
				return this.CURRENTUSER.hasOwnProperty('userId') ? this.CURRENTUSER.userId : 0;
			},
			messagesWithNew() {
				let msg = [...this.messages];
				msg.push({
					messageNpp: 0,
					isNew: true,
					emails: '{"to":[]}',
					attachmentsData : ''
				})
				return msg;
			}
		},

		methods: {
			preventDefaults(e) {
				e.preventDefault();
            },
			async onPaste(e) {
				let items = (e.clipboardData || e.originalEvent.clipboardData).items;
                for (let i in items) {
                    let item = items[i];
                    if (item.kind == 'file') {
                        let files = [];
                        files.push(item.getAsFile());
                        await this.onFileUpload(files)
                    }
                }
			},
			async onDrop(e) {
                await this.onFileUpload(e.dataTransfer.files)
            },
			attachDeg(attachment, isNew) {
				if (isNew) {
					return attachment.file.deg ? attachment.file.deg : 0;
				}
				else {
					return attachment.deg ? attachment.deg : 0;
                }
				return 0;
            },
			attachmentsDataForNew() {
				let out = [];
				this.files.forEach(file => {
					let d = this.pathSeemsToBeImage(file.name) ? file.data : null;
					let {name: file_name, size: file_size, type: file_type} = file;
					out.push({file_name, file_size, file_type, file_data: d, file});
				});
				return out;
			},
			rotateImage(direction) {
				this.imageDeg += direction * 90;
				this.imageDeg %= 360;
				this.canSaveDeg = this.messageToImageShow.canSave();
			},
			saveImageDeg(message) {
				let data = {
                    messageNpp: message.messageNpp,
					attachments: message.attachmentsData
				}
				this.$http.post("data/UpdateMessageAttachments", data)
					.then((response) => {
						//console.log(response)
						this.canSaveDeg = false;
					})
					.catch((error) => {
						//console.log(error)
					});
            },
			onSendMessageEvent(tn) {
				console.log(tn);
			},
			readFileData(file) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						let data = reader.result.split(',')[1];
						resolve({data, type: file.type});
					}
					reader.onerror = error => reject(error);
				})
			},
			async storeUserData() {
				let storage = {
					changes: this.changes,
					tn: this.tn,
					newMessage: this.newMessage,
					files: this.files
				};
				localStorage.setItem("Ticket" + this.tn, JSON.stringify(storage));
			},
			onAttchmentsChanged() {
				this.storeUserData();
			},
			onSignalrConnectionChanged(data) {
				this.getUploadQR(data.connectionId);
            },
			onInjectFile(ticketNumber) {
				if (ticketNumber != this.tn) {
					return;
				}
				this.recoverUnsavedDataFromLocalStorage();
			},
			showEmailDialogFunc() {
				this.showEmailDialog = true;
			},
			qrClicked() {
				//return;
				window.open(this.qrUrl)
			},
			sendUrlEmail() {
				this.urlEmailSending = true;
                axios.post("data/SendUrlEmail", JSON.stringify({ email: this.urlEmail, url: this.qrUrl }), { headers: { "Content-Type": "application/json" } }
				).then(
					(response) => {
						this.showEmailDialog = false;
                        this.$store.dispatch("showSnackBar", {
                            snackText: "Письмо отправлено"
						})
					}
				).catch(error => {
					this.$store.dispatch("showSnackBar", {
						snackText: "Произошла ошибка при отправке письма"
					});
				}).finally(
					() => { this.urlEmailSending = false; }
				)
            },
			updateMessages() {
				this.clickUpdate();
				this.scrollMessagesListToBottom();
				
				this.$store.dispatch('SET_TICKETLASTUPDATETIME', {
							ticketNpp: this.npp,
							clientNpp: this.CURRENTAPTEKA.npp,
							userId: this.USERID
						});
			},
			closeWindow() {
				this.$emit("closeTab", this.CURRENTTABID, Number.parseInt(this.tn ? this.tn : 0));
			},
			createTicket(messageText, cbFail) {
				return new Promise(resolve => {
					var title = this.newTicketTitleFunc;
					axios
					.post(
						"data/CreateTicket",
						JSON.stringify({
							titleId: title.titleId,
							titleName: title.titleName,
							customer: this.CURRENTAPTEKA.npp,
							userId: this.USERID,
							state: "new",
							priority: "normal",
							agent: "27", //Administrator по-умолчанию для новых заявок
							message: messageText,
							attachmentsData: this.attachmentsData.length > 0 ? JSON.stringify(this.attachmentsData) : '',
							idapt: this.CURRENTAPTEKA.idapt,
							clientEmails: this.createEmailsObjectNew() ? JSON.stringify(this.createEmailsObjectNew()) : ''
						}),
						{headers: {"Content-Type": "application/json"}}
					)
					.then(response => {
						if (response.data.statusCode > 200) {
							this.$store.dispatch("showSnackBar", {
								snackText: `Ошибка! создания новой заявки`
							});
							console.error(response.data.reasonPhrase);
							return;
						}
						let string = response.data.reasonPhrase;
						let arr = string.split(';');
						let ticketNpp = arr[1];
						let messageNpp = arr[2];
						let ticketNumber = arr[3];

						//сохраняем вложения на сервер
						let final = () => {
							resolve({success: true, tn: ticketNumber});
							return;
							//закрывем вкладку
							localStorage.removeItem("Ticket" + this.tn);
							this.closeWindow();
							this.$emit("createTicket"); //обновление списка заявок
							this.$store.dispatch("showSnackBar", {snackText: `Создана заявка ${ticketNumber}`});
						};
						let fsize = this.files.length;
						if (fsize > 0) {
							var files = [];
							var injFiles = [];
							for (let i = 0; i < fsize; i++) {
								const file = this.files[i];
								(file.injected ? injFiles : files).push(file);
							}
							this.uploadFilesToServer(files, injFiles, ticketNpp, messageNpp)
								.then(response => {
									console.log(response);
								}, error => console.error(error))
								.finally(() => {
									final();
								});
						} else {
							final();
						}
					})
					.catch(error => {
						cbFail(error);
					})
					.then(() => {
						// always executed
					});
				});
				
			},
			sendFunc(message) {
				return new Promise((resolve, reject) => {
					axios
					.post(
						"data/saveMessage",
						JSON.stringify({
							newMessage: message,
							messageForMail: message,
							ticketNumber: this.tn,
							clientNpp: this.CURRENTAPTEKA.npp,
							userId: this.USERID,
							attachmentsData: this.attachmentsData.length > 0 ? JSON.stringify(this.attachmentsData) : '',
							idapt: this.CURRENTAPTEKA.idapt,
							number: this.ticketNumber,
							state: this.messages[0].state,
							title: this.ticketTitle,
							clientEmails: this.createEmailsObject() ? JSON.stringify(this.createEmailsObject()) : '',
						}),
						{headers: {"Content-Type": "application/json"}}
					)
					.then(resp => {
						if (resp.data.statusCode > 200) {
							this.$store.dispatch("showSnackBar", {
								snackText: `Произошла ошибка при записи сообщения!`
							});
							console.error(resp.data.reasonPhrase);
							return;
						}

						let string = resp.data.reasonPhrase;
						let arr = string.split(';');
						let messageNpp = arr[1];

						//сохраняем вложения на сервер
						if (this.files.length > 0) {
							const fsize = this.files.length;
							var files = [];
							var injFiles = [];
							for (let i = 0; i < fsize; i++) {
								const file = this.files[i];
								(file.injected ? injFiles : files).push(file);
							}
							this.uploadFilesToServer(files, injFiles, this.npp, messageNpp)
								.then(response => {
									console.log(response);
								}, error => {
									console.error(error);
									this.$store.dispatch("showSnackBar", {snackText: `Произошла ошибка при сохранении вложений на сервер.`});
								})
								.finally(() => {
									//очищаем массив вложений
									this.files = [];
									this.scrollMessagesListToBottom();
								});
						}

						//обновляем в таблице HistoryMessages время последнего просмотра заявки
						this.$store.dispatch('SET_TICKETLASTUPDATETIME', {
							ticketNpp: this.npp,
							clientNpp: this.CURRENTAPTEKA.npp,
							userId: this.USERID
						});

						this.$store.dispatch("showSnackBar", {
							snackText: "Сообщение отправлено"
						});

						this.getMessages(this.tn)
							.then(response => {
								this.messages = response.data;
								this.toggleShowTextarea();
								this.calcHeight();
								//прокручиваем список сообщений вниз
								this.scrollMessagesListToBottom();
							})
							.catch(error => {
								console.error(error);
								this.$store.dispatch("showSnackBar", {
									snackText: "Произошла ошибка при получении списка сообщений"
								});
							});
						resolve(true)
					})
					.catch(error => {
						console.error(error);
						this.$store.dispatch("showSnackBar", {
							snackText: "Произошла ошибка при записи нового сообщения"
						});
						reject(false)
					})
					.finally(() => this.loading = false);
				})
			},
			async sendMessage(message) {
				this.loading = true;
				let cbError = (error) => {
					this.inProcess = false;
						console.error(error);
						this.$store.dispatch("showSnackBar", {
							snackText: "Ошибка создания новой заявки"
						});
				};

				if (this.tn == 0) {
					let result = await this.createTicket(message, cbError);
					if (result.success) {
						//закрывем вкладку
						await QbIdb.setFiles(this.db, this.tn, null);
						localStorage.removeItem("Ticket" + this.tn);
						this.closeWindow();
						this.$emit("createTicket"); //обновление списка заявок
						this.$store.dispatch("showSnackBar", {snackText: `Создана заявка ${result.tn}`});
					};
					this.loading = false;
					return;
				}
				else {
					if (await this.sendFunc(message)) {
						await QbIdb.setFiles(this.db, this.tn, null);
					}
				}
			},
			checkUnsavedNewMessage() {
				if (this.changes.some(elem => elem === "newMessage")) {
					this.showDialogForNewMessage = true;
				} else {
					this.toggleShowTextarea();
				}
			},
			startTimer() {
				console.log("Запущен таймер");
			},
			stopTimer() {
				console.log("Остановлен таймер");
			},
			toggleShowTextarea() {
				// this.showTextarea = !this.showTextarea;
				this.showDialogForNewMessage = false;
				this.newMessage = ''; //очищаем окно сообщения перед toggleChanges()
				// this.newMessage = this.initNewMessage(this.lastAgentMessage); //заполняем окно сообщения начальными данными
				this.toggleChanges(); //нужно для удаления записи из localStorage
				this.calcHeight();
			},
			calcHeight() {
				this.heightUpdateProcess = true;
				//расчет высоты чата
				let pageHeight = document.documentElement.clientHeight;
				let updateTimeToolbarHeight = document.getElementById("update-time-toolbar") ?
					document.getElementById("update-time-toolbar").clientHeight : 0;
				let toolbar = document.getElementById("application-toolbar");
				let toolbarHeight = toolbar.clientHeight;
				let tabsPanel = document.getElementById("second-tabs-panel");
				let tabsPanelHeight = tabsPanel.clientHeight
					? tabsPanel.clientHeight
					: 48;
				let messagesToolbar = document.getElementById("messages-toolbar");
				let messagesToolbarHeight = messagesToolbar.clientHeight
					? messagesToolbar.clientHeight
					: 84;
				
				let newsMarquee = document.getElementById('news-marquee');
				let newsMarqueeHeight = newsMarquee ? newsMarquee.clientHeight : 0;

				let attph = document.getElementById('attachments-placeholder');
				let attphHeight = attph ? attph.clientHeight : 0;
				attphHeight = 0;

				let paddingMarginHeight = 90;
				let magic = this.tn != 0 ? -6 : -30;

				let freeSpace =
					pageHeight -
					updateTimeToolbarHeight -
					toolbarHeight -
					tabsPanelHeight -
					messagesToolbarHeight -
					paddingMarginHeight -
					newsMarqueeHeight - 
					attphHeight + magic;

				this.tableHeight = freeSpace;
			},
			getMessages(ticketNumber) {
				return axios.post(
					"data/getMessages",
					JSON.stringify({ticketNumber: ticketNumber}),
					{
						headers: {"Content-Type": "application/json"}
					}
				);
			},
			updateTicketMessagesFromParent() {
				this.getMessages(this.tn)
					.then(response => {
						this.messages = response.data;
						this.toggleShowTextarea();
						this.toggleChanges(); //проверяем наличие изменений на странице
					})
					.catch(error => console.error(error));
			},
			updateTicketsInputData() {
				let paramsData = {
					row_num_begin: (this.getCurrentPage() - 1) * this.getRowsPerPage() + 1,
					row_num_end: this.getCurrentPage() * this.getRowsPerPage()
				};
				this.$http
					.get("data/GetClientTicketsPagination", {
						params: paramsData
					})
					.then(
						response => {
							this.$store.dispatch(
								"SET_TICKETSINPUTDATA",
								Array.from(response.body)
							);
						},
						error => console.error(error)
					);
			},
			saveChanges() {
				if (this.changes.some(elem => elem === "priority")) {
					this.savePriority();
					let index = this.changes.findIndex(elem => elem === "priority");
					this.changes.splice(index, 1);
				}
				if (this.changes.some(elem => elem === "agent")) {
					this.saveAgent();
					let index = this.changes.findIndex(elem => elem === "agent");
					this.changes.splice(index, 1);
				}
				this.$store.dispatch("showSnackBar", {
					snackText: "Изменения сохранены"
				});
				this.priorityBackgroundColor = "transparent";
				this.agentBackgroundColor = "transparent";
				this.saveButtonColor = "md-primary";
			},
			calcPriorityBorderLeftColor(selectedPriority) {
				for (let priority of this.PRIORITIES) {
					if (priority.name == selectedPriority) return priority.color;
				}
				return "";
			},
			toggleChanges() {
				//записываем текст из окна ввода нового сообщения
				if (this.newMessage !== "") {
					if (this.changes.every(elem => elem !== "newMessage")) {
						this.changes.push("newMessage");
					}
				} else {
					let index = this.changes.findIndex(elem => elem === "newMessage");
					if (index !== -1) {
						this.changes.splice(index, 1);
						// this.agentBackgroundColor = "transparent"; //убираем выделение
					}
				}
				this.storeUserData();
			},
			async recoverUnsavedDataFromLocalStorage() {
				//восстанавливаем на вкладке несохраненные изменения
				let storage = JSON.parse(localStorage.getItem("Ticket" + this.tn));
				
				if (storage) {
					this.newMessage = storage.newMessage;
					this.changes = storage.changes;
					//this.files = storage.files ? storage.files : [];
				} else {
					this.newMessage = "";
					//this.files = [];
				}
				this.files = await QbIdb.getFiles(this.db, this.tn);
			},
			calcTypeOfMessage(message) {
				let agent = message.messageAgent
				if (agent && agent !== "") {
					return "agent-message";
				}
				return message.isNew ? "new-message" : "client-message";
			},
			calcNewMessage(messageNpp) {
				if (this.newMessages.find(x => x.npp === messageNpp)) return "background-color:#5ae27061";
				return "";
			},
			calcSeenedByAgentsMessage(messageNpp, messageAgent) {
				if (this.seenedByAgentsMessages.find(x => x.npp === messageNpp && messageAgent !== '')) return '#448AFF';
				return '#E0E0E0';
			},
			changeTicketTitle() {
				this.isChangeTicketTitle = !this.isChangeTicketTitle;
				this.newTicketTitle = this.ticketTitle;
			},
			clickUpdate() {
				this.loading = true;
				this.getMessages(this.tn)
					.then(response => {
						this.messages = response.data;
					})
					.catch(error => {
						console.error(error);
						this.$store.dispatch("showSnackBar", {
							snackText: "Ошибка обновления списка сообщений"
						});
					})
					.finally(() => {
						this.loading = false;

						//получаем новые сообщения
						this.getNewMessages(this.tn, this.CURRENTAPTEKA.npp, this.USERID).then(response => {
							this.newMessages = response.data;
						}, error => console.log(error));

						//получаем просмотренные агентами сообщения
						this.getSeenedByAgentsMessagesOfTickets(this.tn).then(response => {
							this.seenedByAgentsMessages = response.data;
						}, error => console.error(error));

					});
			},
			notify(message, tag) {
				// Let's check if the browser supports notifications
				if (!("Notification" in window)) {
					console.log("This browser does not support system notifications");
				}

				// Let's check whether notification permissions have already been granted
				else if (Notification.permission === "granted") {
					// If it's okay let's create a notification
					new Notification("Уведомление QB", {
						body: message,
						requireInteraction: false,
						tag: tag,
						// icon: $('#notify_icon').prop('src'),
						renotify: false
					});
				}

				// Otherwise, we need to ask the user for permission
				else {
					Notification.requestPermission().then(function (permission) {
						// If the user accepts, let's create a notification
						if (permission === "granted") {
							new Notification("Уведомление QB", {
								body: message,
								requireInteraction: false,
								tag: tag,
								// icon: $('#notify_icon').prop('src'),
								renotify: false
							});
						}
					});
				}
			},
			updateMessagesFromParent() {
				this.clickUpdate();
			},
			getNewMessages(ticketNpp, clientNpp, userId) {
				return this.$http.get("data/GetNewMessagesOfTickets", {
					params: {ticket_npp: ticketNpp, client_npp: clientNpp, userId: userId}
				});
			},
			updateTimeInTables() {
				//обновляем в таблице HistoryMessages время последнего просмотра заявки
				if (this.tn == 0) {
					return;
				}
				this.$store.dispatch('SET_TICKETLASTUPDATETIME', {
					ticketNpp: this.tn,
					clientNpp: this.CURRENTAPTEKA.npp,
					userId: this.USERID
				});
			},
			move($event) {
				if (this.hasNewMessages && this.mouseMoveCounter === 0 && !this.firstLoad) {
					this.mouseMoveCounter++;

					//убираем заявку из массива непросмотренных
					if (this.TICKETSWITHCHANGES.find(x => x.npp === this.npp)) {
						let index = this.TICKETSWITHCHANGES.findIndex(x => x.npp === this.npp);
						this.$store.dispatch('REMOVE_TICKETSWHITHCHANGES', index);
					}

					//убираем заявку из массива USERTICKETSWITHCHANGES
					this.$store.dispatch('REMOVE_USERTICKETSWITHCHANGES', this.ticketNumber);

					//через 2 секунды обновляем время просмотра заявки, для запуска процедуры автообновления
					setTimeout(() => {
						this.updateTimeInTables();
						this.newMessages = [];
						this.mouseMoveCounter = 0;
					}, 2000);
				}
			},
			getSeenedByAgentsMessagesOfTickets(ticketNpp) {
				return this.$http.get("data/GetSeenedByAgentsMessagesOfTickets", {
					params: {ticket_npp: ticketNpp}
				});
			},
			scrollMessagesListToBottom() {
				setTimeout(() => {
					let ul = document.getElementById('mlist');
					ul.scrollTo(0, ul.scrollHeight);
				}, 200);
			},
			calcMessageAttachments(attachmentsData, takeNew = false) {
				let att = takeNew ? this.attachmentsDataForNew() : JSON.parse(attachmentsData);
                for (let i = 0; i < att.length; i++) {
                    att[i].idx = i;
                }
                return att;
			},
			calcTypeOfAttachment(attachment) {
				let fileName = attachment.file_name;
				//определяем расширение файла
				let fileType = fileName.slice((Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1);
				fileType = fileType.toLowerCase();
				return this.KNOWNFILETYPES.includes(fileType) ? `/dist/svg/${fileType}.svg` : `/dist/svg/raw.svg`;
			},
			calcTypeOfAttachmentForAttachedFiles(file) {
				let fileName = file.name;
				//определяем расширение файла
				let fileType = fileName.slice((Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1);
				fileType = fileType.toLowerCase();
				return this.KNOWNFILETYPES.includes(fileType) ? `/dist/svg/${fileType}.svg` : `/dist/svg/raw.svg`;
			},
			getUploadQR(connectionId) {
				if (!connectionId) {
					return;
                }
				this.qrData = "";
				this.qrUrl = "";
                axios.post("data/GetUploadQR", JSON.stringify({
					connectionId: connectionId,
					ticketNumber: this.tn,
					ticketId: this.ticketRealId
				}), { headers: { "Content-Type": "application/json" } }).then(
					response => {
						this.qrData = 'data: image/png; base64,' + response.data.bc;
						this.qrUrl = response.data.url;
						this.uploadKey = response.data.uploadKey;
					},
					error => {

                    }
				)
            },
            getAttachemntData(path, successFunc) {
                axios.get("data/GetAttachmentData", {
                    params: {
                        file: path
                    },
                }
                ).then(
                    response => {
                        successFunc(response)
                    },
                    error => {
                        this.showSnack(`Произошла ошибка при загрузке файла вложения: ${error.message}`);
                    }
                )
            },
            pathSeemsToBeImage(path) {
                let imgSuffs = ['bmp', 'gif', 'jpeg', 'jpg', 'tiff', 'tif', 'png'];
                let suff = path.slice((Math.max(0, path.lastIndexOf(".")) || Infinity) + 1).toLowerCase();
                return imgSuffs.indexOf(suff) != -1;
            },
			messageAttachmentClicked(message, attachment) {
				if (!message.isNew) {
					this.attachmentClicked(message, attachment);
				}
				else {
					this.newMessageAttachmentClicked(attachment.file)
				}
			},
            attachmentClicked(message, attachment) {
				
				if (this.pathSeemsToBeImage(attachment.file_name)) {
					this.imageDeg = attachment.deg ? attachment.deg : 0;
                    this.canSaveDeg = false;
                    this.showImageDialog(message, attachment);
                }
                else {
                    this.getAttachmentFile(attachment);
                }
            },
            showImageDialog(message, attachment) {
                let attFunc = this.getAttachemntData;
				let downloadFunc = this.getAttachmentFile;
				let saveDegFunc = this.saveImageDeg;
				let setAttDegFunc = (att) => {
					att.deg = this.imageDeg % 360;
				};
				let setDeg = (deg) => {
					this.imageDeg = deg;
				}
                let canSave = (deg) => {
                    deg = deg ? deg : 0;
                    return this.imageDeg % 360 != deg % 360;
                }
                const atts = this.calcMessageAttachments(message.attachmentsData);
				attFunc(attachment.file_path, (result) => {
                    const size = atts.length;
                    let imgDict = [];
                    let currentAttachment;
                    for (let i = 0; i < size; i++) {
                        if (atts[i].idx == attachment.idx) {
                            currentAttachment = atts[i];
                        }
                        if (this.pathSeemsToBeImage(atts[i].file_path)) {
                            imgDict.push(atts[i]);
                        }
                    }

                    let imgFunc = (respData, path) => {
                        if (respData.error) {
                            this.showSnack(`Произошла ошибка при загрузке файла вложения`);
                        }
                        return respData.nodata || respData.error
                            ? this.calcTypeOfAttachmentForAttachedFiles({ name: path })
                            : `data:image/jpeg; base64,${respData.fileData}`;
                    };

					let loadFunc = (msgData, step) => {
						let newAtt = imgDict[imgDict.indexOf(msgData.att) + step];
						setDeg(newAtt.deg ? newAtt.deg : 0);
                        attFunc(newAtt.file_path, (result) => {
                            msgData.att = newAtt;
                            msgData.file = imgFunc(result.data, newAtt.file_path);
                        })
                    }
                    this.messageToImageShow = {
                        att: currentAttachment,
                        file: imgFunc(result.data, currentAttachment.file_path),
                        allowNext: function (curAtt) {
                            return imgDict[imgDict.length - 1] != curAtt;
                        },
                        allowPrev: function (curAtt) {
                            return imgDict[0] != curAtt;
                        },
						next: function (msgData) {
							loadFunc(msgData, 1);
                        },
                        prev: function (msgData) {
							loadFunc(msgData, -1);
                        },
						download() {
							downloadFunc({file_path: currentAttachment.file_path, file_name: currentAttachment.file_name})
						},
						saveDeg() {
							setAttDegFunc(this.att);
							message.attachmentsData = JSON.stringify(atts);
							saveDegFunc(message);
						},
						canSave() {
							return canSave(this.att.deg);
                        }
                    };
                    this.showImage = true;
                });
            },
			
			newMessageAttachmentClicked(file) {
				this.imageDeg = file.deg ? file.deg : 0;
				this.canSaveDeg = false;
				if (file && file['type'] && file['type'].split('/')[0] === 'image') {
					this.showImageDialogNewMessage(file);
				}
				else {
					this.downloadNewMessageAttachment(file);
					return;
				}
			},
			downloadNewMessageAttachment(file) {
				const blob = new Blob([Buffer.from(file.data, "base64")], {type: file.type});
				const url = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', file.name);
				document.body.appendChild(link);
				link.click();
				link.remove();
				window.URL.revokeObjectURL(url);
			},
			getImageFilesForNewMessage(file) {
				let currIdx = -1;
				let attList = [];
				for (let i = 0; i < this.files.length; i++) {
					if (file == this.files[i]) {
						currIdx = attList.length;
					}
					let attData = this.files[i].injected ? this.createInjectedFileUrl(this.files[i]) : this.createFileUrl(this.files[i]);
					if (!attData.isImage) {
						continue;
					}
					attList.push({ fileData: attData.data, rawFile: attData.rawFile });
				}
				return {
					data: attList,
					currIdx
				};
			},
			showImageDialogNewMessage(file) {
				let fileData = this.getImageFilesForNewMessage(file);
				let downloadFunc = this.downloadNewMessageAttachment;
				let setDeg = (deg) => {
					this.imageDeg = deg;
				}
				let commitFiles = () => {
					QbIdb.setFiles(this.db, this.tn, this.files);
					this.canSaveDeg = false;
				}
				let canSave = (deg) => {
					deg = deg ? deg : 0;
                    return this.imageDeg % 360 != deg % 360;
                }
				this.messageToImageShow = {
					att: fileData.currIdx,
					file: fileData.data[fileData.currIdx].fileData,
                    rawFile: fileData.data[fileData.currIdx].rawFile,
					allowNext: function (curAtt) {
						return curAtt < fileData.data.length -1;
					},
					allowPrev: function (curAtt) {
						return curAtt != 0;
					},
					next: function (msgData) {
						this.setMsgData(msgData, fileData.data[++msgData.att]);
					},
					prev: function (msgData) {
                        this.setMsgData(msgData, fileData.data[--msgData.att]);
					},
					download() {
						downloadFunc(this.rawFile);
					},
					saveDeg(deg) {
						this.rawFile.deg = deg;
						commitFiles();
					},
					setMsgData(msgData, data) {
                        msgData.file = data.fileData;
                        msgData.rawFile = data.rawFile;
                        setDeg(msgData.rawFile.deg ? msgData.rawFile.deg : 0)
					},
					canSave() {
                        return canSave(this.rawFile.deg);
                    }
				}
				this.showImage = true;
			},
			getAttachmentFile(attachment) {
				// this.$store.dispatch("showSnackBar", {snackText: `Открытие окна для сохранения файла`});
				axios.get("data/GetAttachmentFile", {
					params: {
						file_path: attachment.file_path
					},
					responseType: 'arraybuffer'
				})
					.then(response => {
						try {
							let headers = response.headers;
							const blob = new Blob([response.data], {type: headers['content-type']});
							const url = window.URL.createObjectURL(blob);
							let link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', attachment.file_name);
							document.body.appendChild(link);
							link.click();
							link.remove();
							window.URL.revokeObjectURL(url);
						} catch (error) {
							this.$store.dispatch("showSnackBar", {snackText: `Ошибка открытия файла вложения: ${error.message}`});
						}
					}, error => {
						console.log(error);
						this.$store.dispatch("showSnackBar", {snackText: `Произошла ошибка при загрузке файла вложения!`});
					});
			},
            createFileUrl(file) {
                let isImage = false;
				let res = null;
				if (!file) {
                    res = '#';
                }
				
                if (file && file['type'] && file['type'].split('/')[0] === 'image') {
					isImage = true;
                    res = URL.createObjectURL(file)
                }
				else {
					res = this.calcTypeOfAttachmentForAttachedFiles(file);
				}
				return {
					data: res,
					isImage
				}
			},
            createInjectedFileUrl(file) {
				let isImage = false;
				let res = null;
                if (!file) {
                    res = '#';
                }
				if (file && file['type'] && file['type'].split('/')[0] === 'image') {
                    res = `data:${file.type};base64,${file.data}`;
					isImage = true;
                }
				else {
					res = this.calcTypeOfAttachmentForAttachedFiles(file)
				}
				return {
					rawFile: file,
					data: res,
					isImage
				}
            },
			bytesToSize(bytes) {
				const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) return 'n/a';
				const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10);
				if (i === 0) return `${bytes} ${sizes[i]}`;
				return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
			},
			async onFileUpload(fileList) {
				try {
					let filec = fileList.length;
					for (let i = 0; i< filec; i++) {
						let fileData = await this.readFileData(fileList[i]);
						let data = {
							data: fileData.data,
							type: fileData.type,
							size: fileList[i].size,
							name: fileList[i].name,
							injected: true
						}
						this.files.push(data);
                        this.scrollMessagesListToBottom();
					}
					await QbIdb.setFiles(this.db, this.tn, this.files);
					document.getElementById("file-input").value = null;
                    this.scrollMessagesListToBottom();
				} catch (error) {
					this.$store.dispatch("showSnackBar", {snackText: `Ошибка выбора файлов: ${error.message}`});
				}
			},
			uploadFilesToServer(files, injFiles, ticketNpp, messageNpp) {
				let formData = new FormData();
				files.forEach(file => formData.append('files', file));
				formData.append('injectedFiles', JSON.stringify(injFiles));
				formData.append('ticketNpp', ticketNpp);
				formData.append('messageNpp', messageNpp);

				return this.$http.post('data/UploadAttachmentsFiles', formData);
			},
			clickFileInput() {
				try {
					document.getElementById('file-input').click();
					// this.$store.dispatch("showSnackBar", {snackText: `Открытие окна для выбора файлов`});
				} catch (error) {
					this.$store.dispatch("showSnackBar", {snackText: `Ошибка открытия окна выбора файлов: ${error.message}`});
				}
			},
			async removeAttachment(attachment) {
				let index = this.files.indexOf(attachment);
				if (index !== -1) this.files.splice(index, 1);
				await QbIdb.setFiles(this.db, this.tn, this.files);
			},
			closeChatMessagesWindow() {
				this.showChatMessagesWindowDialog = false;
				// this.$store.dispatch('SET_SHOWCHATMESSAGESWINDOWDIALOG', false);
				this.recoverUnsavedDataFromLocalStorage(); //для удаления автоматически вставляемого текста (Здраствуйте..., Работы выполнены...)
			},
			updateNewMessage(data) {
				this.newMessage = data;
				this.toggleChanges(); //сохраняем сообщение в localStorage, чтобы сохранить его при переходе на другую вкладку
				this.showChatMessagesWindowDialog = false;
				// this.$store.dispatch('SET_SHOWCHATMESSAGESWINDOWDIALOG', false);
			},
			correctChatMessages() {
				if (!this.tn || this.tn == 0) {
					return;
				}
				if (this.ticketStateRaw != 'close' ) {
					//this.showChatMessagesWindowDialog = true;
				}
				else {
					this.showTicketMessageAction = true;
				}
			},
			caclAptekaNameByEmail(email) {
				const userObj = this.LOGINUSERS.find(x => x.email.toLowerCase() === email.toLowerCase());
				if (userObj) {
					const aptekaObj = this.COMPANYS.find(x => +x.idapt === +userObj.idapt);
					let aptekaName = '';
					if (aptekaObj) aptekaName = aptekaObj.idapt === 50163 ? '' : aptekaObj.name + ' /';
					const lastName = userObj.lastName ? userObj.lastName : '';
					const firstName = userObj.firstName ? userObj.firstName : '';
					const middleName = userObj.middleName ? userObj.middleName : '';
					const userEmail = `<${email}>` || '';
					return `${aptekaName} ${lastName} ${firstName} ${middleName} ${userEmail}`;
				} else {
					return `<${email}>`;
					// return `неизвестный получатель <${email}>`;
				}
			},
			parseEmails(emails, messageClient, clientEmail) {
				try {
					const data = JSON.parse(emails.toLowerCase());
					const {to, copy, bcc} = data;
					//в письме от клиента в поле To первым записан email отправителя (From), достаем его
					if (messageClient) {
						// const from = Array.isArray(to) ? to[0] : '';
						if (Array.isArray(to)) {
							to.shift(); //удаляем первый элемент, т.к. он из поля От:
						}
						let toFiltered = Array.isArray(to) ? to.filter(x => x !== clientEmail).map(x => this.caclAptekaNameByEmail(x)) : [];
						// toFiltered = this.unique(toFiltered);
						let copyFiltered = Array.isArray(copy) ? copy.filter(x => x !== clientEmail).map(x => this.caclAptekaNameByEmail(x)) : [];
						// copyFiltered = this.unique(copyFiltered);
						return {
							//from: {key: 'От: ', value: from}, // на клиентском сайте поле "От" не показываем, т.к. в заголовке сообщения уже указана эта информация
							to: {
								key: 'Кому: ',
								value: toFiltered.join().replace(/,/g, ', ')
							},
							copy: {
								key: 'Копия: ',
								value: copyFiltered.join().replace(/,/g, ', ')
							},
							// bcc: {key: 'Скрытая : ', value: Array.isArray(bcc) ? bcc.join().replace(/,/g, ', ') : ''}
						};
					} else {
						let toFiltered = Array.isArray(to) ? to.filter(x => x !== clientEmail).map(x => this.caclAptekaNameByEmail(x)) : [];
						// toFiltered = this.unique(toFiltered);
						let copyFiltered = Array.isArray(copy) ? copy.filter(x => x !== clientEmail).map(x => this.caclAptekaNameByEmail(x)) : [];
						// copyFiltered = this.unique(copyFiltered);
						return {
							to: {
								key: 'Кому: ',
								value: toFiltered.join().replace(/,/g, ', ')
							},
							copy: {
								key: 'Копия: ',
								value: copyFiltered.join().replace(/,/g, ', ')
							},
							// bcc: {key: 'Скрытая : ', value: Array.isArray(bcc) ? bcc.join().replace(/,/g, ', ') : ''}
						};
					}
				} catch (e) {
					console.error(e);
					return '';
				}
			},
			unique(arr) {
				const tempArr = arr.filter(x => x.indexOf('неизвестный получатель') !== -1);
				//если "неизвестный получатель" более одного,то заменяем их на один "неизвестные получатели"
				if (tempArr.length > 1) {
					arr = arr.filter(x => x.indexOf('неизвестный получатель') === -1);
					arr.push('неизвестные получатели: ' + tempArr.map(x => x.replace('неизвестный получатель ', '')).join(''));
				}
				return arr;
			},
			createEmailsObject() {
				let obj = Object.create(null);
				if (this.clientEmail) obj['to'] = [this.clientEmail];
				return !isEmpty(obj) ? obj : null;
			},
            createEmailsObjectNew() {
                let obj = Object.create(null);
                if (this.clientEmailNew) obj['to'] = [this.clientEmailNew];
                return !isEmpty(obj) ? obj : null;
            },
			calcToFromEmails(emails) {
				try {
					const emailsArr = JSON.parse(emails);
					return emailsArr["to"] ? emailsArr["to"][0] : '';
				} catch (error) {
					console.error(error);
					return '';
				}
			},
			calcMessageTitle(message) {
				let messageTitle = `${message.messageClient ? message.messageClient + ' /' : ''} ${message.userFullName ? message.userFullName : ''} ${message.userEmail ? '<' + message.userEmail + '>' : ''}`;
				if (message.clientNpp === 901) {
					try {
						const email = message.emails ? JSON.parse(message.emails)["to"][0] : ''; // извлекаем email отправителя сообщения
						messageTitle = email ? this.caclAptekaNameByEmail(email) : '';
					} catch (error) {
						console.error(error);
						messageTitle = '';
					}
				}
				return messageTitle;
			},
			calcClientMessage(message) {
				if (+message.messageNpp === +this.messages[0].messageNpp) return message.text; //не обрезаем цитируемый текст у первого сообщения
				return message.text
					.split('\n')
					.filter(str => !str.startsWith('>'))
					.filter(str => str.indexOf('"Кверти+ Помощь" <help@qwerty.plus>:') === -1)
					.join('\n')
					.trim();
			},
			onSelectMenu(message) {
				this.editableMessage = {...message};
				this.showEditMessageWindow = true;
			},
			onInvalidateUploadSession() {
				this.getUploadQR(this.$QBHub.connectionId);
            },
		},
		updated() {
			this.calcHeight();
		},

		async mounted() {
			//console.log("messages mounted()");
			//toggleChanges() неявно запускается при установке значений свойств selectedPriority, selectedAgent в методе recoverUnsavedDataFromLocalStorage()
			this.loading = true;
			this.tn = this.$route.query["tn"];
            
			// this.$root.$on("closeTabFromParent", this.closeTabFromParent); //подписываемся на событие - закрытие вкладки

			//подписываемся на событие - обновление списка сообщений
			this.$root.$on("updateTicketMessagesFromParent", this.updateTicketMessagesFromParent);

			//подписываемся на событие - обновление списка сообщений (автозагрузка обновлений)
			this.$root.$on("updateMessagesFromParent", this.updateMessagesFromParent);

			//подписываемся на событие - обновление времени последних обновлений в таблицах
			this.$root.$on("updateTimeFromParent", this.updateTimeInTables);

			this.$root.$on('sendMessage', this.onSendMessageEvent);

			// получаем всех клиентов из таблицы Companys
			if (this.COMPANYS.length === 0) await this.$store.dispatch('GET_COMPANYS');

			// получаем всех клиентов из таблицы qbLoginUsers
			if (this.LOGINUSERS.length === 0) await this.$store.dispatch('GET_LOGINUSERS');

			this.getMessages(this.tn)
				.then(response => {
					this.messages = response.data;
					// this.showNotify();
				})
				.catch(error => console.error(error))
				.finally(() => {
					this.recoverUnsavedDataFromLocalStorage();
					this.calcHeight();
					// this.lastUpdateTime = +new Date();
					this.loading = false;

					//через 10 сек. убираем у компонента признак первой загрузки (защита от двойной загрузки данных при переходе на вкладку)
					//если пользователь находится на вкладке более 10сек. то просмотр новых сообщений будет происходить по событию mousemove
					//иначе новые сообщения просматриваются при переходе на вкладку
					setTimeout(() => {
						this.firstLoad = false;
					}, 10000);

					//получаем новые сообщения
					this.getNewMessages(this.tn, this.CURRENTAPTEKA.npp, this.USERID).then(response => {
						this.newMessages = response.data;
					}, error => console.log(error));

					//получаем просмотренные агентами сообщения
					this.getSeenedByAgentsMessagesOfTickets(this.tn).then(response => {
						this.seenedByAgentsMessages = response.data;
					}, error => console.error(error));

					//прокручиваем список сообщений вниз
					this.scrollMessagesListToBottom();
					this.getUploadQR(this.$QBHub.connectionId);
				});
			events.forEach((eventName) => {
				document.body.addEventListener(eventName, this.preventDefaults)
            })
		},
		async created() {
			this.db = await QbIdb.getDb();
            this.$QBHub.$on('connectionIdChanged', this.onSignalrConnectionChanged);
			this.$root.$on('inject-file', this.onInjectFile);
            this.$QBHub.$on('invalidateUploadSession', this.onInvalidateUploadSession);
        },
		beforeDestroy() {
			this.$root.$off("updateTicketMessagesFromParent", this.updateTicketMessagesFromParent);
			this.$root.$off("updateMessagesFromParent", this.updateMessagesFromParent);
			this.$root.$off("updateTimeFromParent", this.updateTimeInTables);
			clearInterval(this.timerId);
            this.$QBHub.$off('connectionIdChanged', this.onSignalrConnectionChanged);
			this.$root.$off('inject-file', this.onInjectFile);
            this.$QBHub.$off('invalidateUploadSession', this.onInvalidateUploadSession);
			//this.$root.$off('sendMessage', this.onSendMessageEvent);
            events.forEach((eventName) => {
                document.body.removeEventListener(eventName, this.preventDefaults)
            })
		},

		watch: {
			$route(toR, fromR) {
				this.loading = true;
				this.tn = toR.query["tn"];
				this.files = [];

				//отключаем запуск уведомлений для данной заявки
				// clearInterval(this.notifyTimerId);
				// this.notifyTimerId = 0;

				this.getMessages(this.tn)
					.then(response => {
						this.messages = response.data;
						// this.showNotify();
					})
					.catch(error => console.error(error))
					.finally(() => {
						this.isChangeTicketTitle = false;
						this.recoverUnsavedDataFromLocalStorage();
						// this.lastUpdateTime = +new Date(); //дата в милисикундах от 1970г
						this.loading = false;

						this.firstLoad = true;
						setTimeout(() => {
							this.firstLoad = false;
						}, 20000);

						//получаем новые сообщения
						this.getNewMessages(this.tn, this.CURRENTAPTEKA.npp, this.USERID).then(response => {
							this.newMessages = response.data;
						}, error => console.log(error));

						//получаем просмотренные агентами сообщения
						this.getSeenedByAgentsMessagesOfTickets(this.tn).then(response => {
							this.seenedByAgentsMessages = response.data;
						}, error => console.log(error));
						this.getUploadQR(this.$QBHub.connectionId);
						this.scrollMessagesListToBottom();
					});

				// this.$store.dispatch("setPageData", {
				// 	header: "Заявка " + this.tn,
				// 	status: "mounted",
				// 	data: {}
				// });
			}
		}
	};
</script>

<style lang="scss" scoped>
		ul {
				padding: 0 20px;
				margin-bottom: 0;
				margin-top: 0;
				overflow-y: auto;
				display: flex;
				flex-direction: column;
		}

		#message-field {
				margin: 10px 0;
		}

		.mes {
				list-style: none;
				border: 1px solid #ced4da;
				border-radius: 5px 5px;
				padding: 10px;
				// background-color: aliceblue;
				// background-color: #DBF4FD;
				margin: 10px 0;
		}

		.new-message {
				background-color: palevioletred;
		}

		.agent-message {
				background-color: #f2f6f9;
				margin-right: 20%;
		}

		.client-message {
				background-color: #dbf4fd;
				margin-left: 20%;
		}
		.new-message {
			background-color: #dbf4fd;
		}

		.message-title {
				font-weight: bold;
				/*margin-left: 20px;*/
		}

		pre {
				text-align: justify;
				/*text-indent: 20px;*/
				white-space: pre-wrap;
				word-wrap: break-word;
		}

		.dialog {
				text-indent: 0;
				margin: 20px 20px 0 20px;
		}

		.md-dialog {
				height: 100%;
				width: 100%;
				/*max-width: 768px;*/
		}

		.done > i {
				position: absolute;
				top: 5px;
				right: 5px;
		}

		li {
				position: relative;
		}

		.attachments {
				border-top: 2px solid lightblue;
				margin-top: 10px;
				padding-top: 2px;
				display: flex;
				align-items1: center;
		}

		.attachments-container {
				display: flex;
				flex-wrap: wrap;
				margin: 10px 0;
		}

		.attachments-item {
				padding: 5px;
				height: 100px;
				width: 100px;
				border: 1px solid #DADADA;
				background-color: #F0F0F0;
				border-radius: 5px;
				margin-right: 10px;
				position: relative;
				display: flex;
				flex-direction: column;
		}

		.attachments-item span {
				font-size: 10px;
				white-space: nowrap;
				overflow: hidden;
		}

		#attachments-link {
				width: max-content
		}

		#attachments-link span {
				text-decoration: underline;
				padding: 10px 10px 10px 0;
		}

		#attachments-link span:hover {
				cursor: pointer;
				text-decoration: none;
		}

		.fadeattachments-enter-active, .fadeattachments-leave-active {
				transition: opacity .5s;
		}

		.fadeattachments-enter, .fadeattachments-leave-to {
				opacity: 0;
		}

		.emails {
				font-size: 11px;
		}

		.emails span {
				font-weight: bold;
		}

		.emails ul {
				list-style: none;
		}

		.message-menu {
			position: absolute;
			top: 3px;
			left: 0;
		}
		.rating-container {
			position: absolute;
			height: 100%;
			width: 20%;
			text-align: center;
		}
		.message-container {
			list-style: none;
		}
		.stars-icon {
			color: gold !important;
		}
		.rating-text {
			text-align: center;
			margin-top: auto;
			margin-bottom: auto;
			display: flex;
		}
		.stars-container {
			font-size: 0px;
		}
		.is-closing {
			position: absolute;
			bottom: 10px;
			right: 5px;
			color: #448aff;
		}
		.is-closing-spec {
			position: absolute;
			bottom: 10px;
			right: 20%;
			padding-right: 5px;
			color: #448aff;
		}
		.attach-controls {
			text-align: center;
		}

		.fit-image {
			width: 72px;
			height: 72px;
			object-fit: contain;
			border-radius: 5px;
			border: solid lightgray 1px;
		}
		.img-container {
			position: relative;
			cursor: pointer;
			margin-left: 5px;

        .remove-attachment {
            position: absolute;
            right: 2px;
            top: 2px;
            height: 16px;
            width: 16px;
            text-align: center;
            line-height: 16px;
            font-size: 18px;
            border-radius: 8px;
            background-color: lightblue;
        }

        .remove-attachment:hover {
            cursor: pointer;
            background-color: #448AFF;
            color: white;
        }
    }
</style>

<style>
		#message-field .md-field.md-has-value .md-textarea {
			font-size: 13px;
		}
		.image-viewer-dialog .md-dialog-container {
			width: auto !important;
			height: auto !important;
		}
		.md-dialog-content.md-theme-default {
			display: flex;
		}
		.email-dialog .md-dialog-container {
			width: auto !important;
			height: auto !important;
		}
		.qr-block {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		.qr-block img {
			margin-left: 5px;
			margin-top: 5px;
		}
		.mes textarea {
			min-height: 100%;
			max-height: 100%;
			resize: none;
			flex-grow: 1;
		}
		.new-message-block {
			display: flex;
		}
		.attach-label {
			margin-left: 5px;
		}
		.attach-controls span {
			font-size: 0.8rem;
		}
		.attach-header {			
			position: absolute;
			right: 17px;
			top: 15px;
			font-size: 0.8rem;
		}
		.new-message-block .md-field {
			margin: 0;
			padding: 5px;
			border-radius: 5px;
			border: 1px lightgray solid;
		}
</style>


// WEBPACK FOOTER //
// Components/supportNew/messages.vue